import { InferType } from 'yup'

import Yup from '@/lib/utils/yup'

export enum Fields {
  password = 'password',
  passwordConfirmation = 'passwordConfirmation',
  token = 'token',
}

export const resetPasswordFormSchema = Yup.object({
  [Fields.password]: Yup.string().required(),
  [Fields.passwordConfirmation]: Yup.string()
    .required()
    .oneOf([Yup.ref(Fields.password)], 'passwordsToMatch'),
  [Fields.token]: Yup.string().required(),
})

export const formName = 'ResetPasswordForm'

export { Fields as ResetPasswordFormFields }

export type ResetPasswordFormSchemaType = InferType<
  typeof resetPasswordFormSchema
>
